import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader/PageHeader';
import { ROUTES } from '@/constants/routes';
import { useGlobalLoader } from '@/hooks/useGlobalLoader';
import { useGetBlogQuery } from '@/modules/blogs/blogsApi';
import { BlogArticleView } from './components/BlogArticleView';
import styles from './BlogPreview.module.scss';

export default function BlogPreview() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const fromCreate = Boolean((location.state as { fromCreate?: boolean } | null)?.fromCreate);

  const { data: post, isLoading } = useGetBlogQuery(id ?? '', {
    skip: !id,
  });

  useGlobalLoader(isLoading && !post);

  return (
    <div className={styles.page}>
      <PageHeader
        actions={
          <div className={styles.headerActions}>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(ROUTES.BLOGS)}>
              Back to blogs
            </Button>
            {id ? (
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => navigate(`/blogs/${id}/edit`)}
              >
                Edit article
              </Button>
            ) : null}
          </div>
        }
      />

      {fromCreate ? (
        <Alert
          type="success"
          showIcon
          message="Article created successfully"
          description="Preview how your article will look. You can edit it anytime from the blog list."
          className={styles.successAlert}
        />
      ) : null}

      {post ? <BlogArticleView article={post} /> : null}
    </div>
  );
}
